import { IConfig } from '@cian/config/shared';

export const getNewbuildingPromosUrl = (config: IConfig): string => {
  return config.getStrict<string>('newbuilding-promos-frontend.baseUrl');
};
